import React, { useEffect, useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useDispatch, useModel } from 'umi';
import get from 'lodash/get';

import classNames from 'classnames';
import { hasAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import { useLeadCardClick } from '@/components/Kanban/LeadCardContext';

import styles from './index.less';
import { LeadModel } from '@/typings/models/Lead';
import { ServiceRequestModel } from '@/typings/models/ServiceRequest';
import { editServiceRequestRequest } from '@/services/api/serviceRequest';

type IProps = {
  editable?: boolean,
  textarea?: boolean,
  isTable?: boolean,
  isCustomer?: boolean,
  property?: string,
  className?: string,
  lead?: LeadModel,
  serviceRequest?: ServiceRequestModel,
  children?: React.ReactNode
}
const EditableTextField = ({
                             children,
                             editable = true,
                             textarea = false,
                             lead,
                             serviceRequest,
                             property,
                             isTable = false,
                             isCustomer = false,
                             className = ""
                           }: IProps) => {
  const [isEditing, setIsEditing] = useState(false)
  const { initialState, setInitialState } = useModel('@@initialState')

  const { setShouldIgnoreClick } = useLeadCardClick()

  // Determine mode based on which prop is provided
  const mode = serviceRequest ? 'serviceRequest' : 'lead'
  const entity = serviceRequest || lead

  const hasEditFieldAccess = hasAccess(
    initialState.currentUser,
    mode === 'lead' ? [PERMISSIONS.Leads.EDIT, PERMISSIONS.BUSINESS_PARTNER] : [PERMISSIONS.ServiceRequests.EDIT, PERMISSIONS.BUSINESS_PARTNER]
  )
  const dispatch = useDispatch()
  const onSubmit = e => {
    setIsEditing(false)
    const value = e.target.value
    if(isCustomer){
      const customerProp = property.split(".")?.[1]
      if(!customerProp) return
      dispatch({
        type: 'customers/change',
        payload: {
          customerId:lead?.customer?.id,
          [customerProp]: value,
        },
      });
    }
    else if (mode === 'serviceRequest') {
      if (value !== serviceRequest[property]) {
        dispatch({
          type: 'serviceRequest/updateCalendarEvent',
          payload: {
            event: {
              id: serviceRequest.id,
              [property]: value,
            },
          },
        });

        editServiceRequestRequest({
          params: {
            serviceRequestId: serviceRequest.id,
          },
          data: {
            [property]: value,
          },
        });
      }
    }
    else if (value !== lead[property]) {
      dispatch({
        type: 'leads/edit',
        payload: {
          leadId: lead.id,
          [property]: value
        }
      })
    }

  }

  useEffect(() => {
    setShouldIgnoreClick(isEditing)
  }, [isEditing])

  const handleFieldClick = () => {
    if (hasEditFieldAccess) setIsEditing(true)
  }

  if (!editable) return <div className={className} onClick={e => e.stopPropagation()}>{children}</div>
  if (!isEditing) return <div className={classNames(className, styles.editableTextWrapper, styles.fieldContainer, {
    [styles.fieldInTable]: isTable
  })} onClick={e => {
    e.stopPropagation()
    handleFieldClick()
  }}>
    {children}
    {hasEditFieldAccess && <EditOutlined className={styles.editIcon} onClick={handleFieldClick} />}
  </div>

  const InputComponent = textarea ? Input.TextArea : Input
  return <InputComponent onClick={e => e.stopPropagation()} bordered={false} size={'small'}
                         className={classNames(styles.fieldContainer, {
                           [styles.editingField]: isEditing,
                           [styles.fieldInTable]: isTable
                         })} autoFocus defaultValue={get(entity, property)} onBlur={onSubmit} onPressEnter={onSubmit} />
}

export default EditableTextField
